import type { DesignModelSlug as DesignModelSlugType } from '@forgd/contract/types'
import { MODEL_STORAGE_KEY } from '#design-tokenomics/utils/draft'
import { DesignModelSlug } from '@forgd/contract/types'
import { useStorage } from '@vueuse/core'

export function useChosenModel() {
  const raw = useStorage<string | null>(MODEL_STORAGE_KEY, null)

  const slug = computed<DesignModelSlugType | null>(() => {
    const parsed = DesignModelSlug.safeParse(raw.value)
    return parsed.success ? parsed.data : null
  })

  function set(next: DesignModelSlugType | null) {
    raw.value = next
  }

  function clear() {
    raw.value = null
  }

  return { slug, set, clear }
}
